
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offres-pro",
      function () {
        return require("private-next-pages/offres-pro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offres-pro"])
      });
    }
  